var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Transform } from 'class-transformer';
export class ModelHistory {
    email;
    firstName;
    lastName;
    name;
    cdate;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelHistory.prototype, "email", void 0);
__decorate([
    Expose({ name: 'first_name' }),
    __metadata("design:type", String)
], ModelHistory.prototype, "firstName", void 0);
__decorate([
    Expose({ name: 'last_name' }),
    __metadata("design:type", String)
], ModelHistory.prototype, "lastName", void 0);
__decorate([
    Expose(),
    Transform(({ obj }) => `${obj.first_name || ''} ${obj.last_name || ''}`.trim()),
    __metadata("design:type", String)
], ModelHistory.prototype, "name", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelHistory.prototype, "cdate", void 0);
